export default {
  translation: {
    navigation: {
      products: 'Products',
      whereToBuy: 'Where to Buy',
    },
    hero: {
      title: 'Crafting Moments Around Your Table',
      description: 'Are you looking for a stylish and practical table for the whole family and guests? Or maybe you want to find a minimalist option for your small kitchen? Then you have come to the right place: our assortment includes practical, modern, Scandinavian, industrial and classic options, and you will easily find one that will best suit the decor of your home or even become its centerpiece.',
      exploreButton: 'Explore Our Collection',
    },
    products: {
      title: 'Our Collection',
      description: 'The collection consists of tables made of quality materials such as chipboard (MDF; MDP), solid wood, metal, glass, plastic, marble and other materials, which guarantee that you will enjoy your furniture for many years. So don\'t wait and start looking for your most important piece of dining furniture!',
      inStock: 'In Stock',
      preOrder: 'Pre-order',
      viewDetails: 'View Details',
      currency: '€',
    },
    cta: {
      title: 'Where to Buy',
      description: 'Our tables are available through our partner marketplace.',
      chat: {
        title: 'Chat With Us',
        description: 'Get instant answers about our products, pricing, and availability.',
        button: 'Start Chat',
      },
      buy: {
        title: 'Buy from our partners',
        description: 'Visit our partner store to buy your items and feel the quality firsthand.',
        button: 'Buy',
      },
    },
    footer: {
      description: 'Every piece tells a story of craftsmanship and dedication.',
      contact: 'Contact Us',
      rights: 'All rights reserved.',
      poweredBy: 'powered by',
    },
    product: {
      backToCollection: 'Back to Collection',
      colors: 'Available Colors',
      features: 'Features',
      specifications: 'Specifications',
      dimensions: 'Dimensions',
      material: 'Material',
      weight: 'Weight',
      finish: 'Finish',
      warranty: '24 months warranty',
      assembly: 'Assembly required',
      delivery: 'Free delivery',
      returns: 'Free Returns',
      buyNow: 'Buy Now',
      notFound: 'Product Not Found',
      returnToCollection: 'Return to Collection',
    },
  },
};